import InputField from "components/fields/InputField";
import {FcGoogle} from "react-icons/fc";
import Checkbox from "components/checkbox";
import {useUserAuth} from "../../context/UserAuthContext";
import React, {useEffect, useState} from "react";
import {Link, NavLink, useNavigate} from "react-router-dom";
import Centered from "layouts/auth/types/Centered";
import Card from "components/card2";
import {MdCode, MdConfirmationNumber, MdFormatListNumbered, MdPassword, MdVpnKey} from "react-icons/md";
import InputFieldPasswordSignIn from "../../components/fields/InputFieldPasswordSignIn";
import axios from "axios";
import PinInput from "react-pin-input";
import CardV3 from "../../components/cardSignInV2";

export default function SignInV2() {

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    let [email, setEmail] = useState("");
    let [password, setPassword] = useState("");
    let [hideFlag, setHideFlag] = useState(true);
    let [disableFlag, setDisableFlag] = useState(false);
    const navigate = useNavigate();
    const [receivedOtp, setReceivedOtp] = useState("");
    const [inputSize, setInputSize] = useState({
        width: "75px",
        height: "75px",
        fontSize: "36px",
    });

    // Timer state
    const [timer, setTimer] = useState(60);
    const [isResendEnabled, setIsResendEnabled] = useState(false);

    const {
        logIn,
        logInV2,
        userToken,
        userstate,
        user,
        accesscontrollevel,
        getEmailOtp,
        getMobileOtp,
        verifyEmailOtp,
        verifyMobileOtp,
        resetPassword,
        checkPasswords,
        isValidEmailAddress,
        isValidMobileNumber
    } = useUserAuth();
    const [errorMessage, setErrorMessage] = useState("");
    const getErrorMessage = (error, fallback = "Unable to process the request. Please try again.") =>
        error?.response?.data?.message || error?.message || fallback;

    const [isTimerActive, setIsTimerActive] = useState(false);

    const handleUserLogin = async (e) => {
        // Prevent the default submit and page reload
        e.preventDefault()

        //setEmail(document.getElementById('email').value)
        email = document.getElementById('email').value
        //setPassword(document.getElementById('password').value)
        password = document.getElementById('password').value

        //console.log("Email", email)
        //console.log("Password: ", password)

        try {
            let loginApiResponse = await logInV2(email, password, receivedOtp)
            //console.log(loginApiResponse)

            if (loginApiResponse.status === 200) {
                setErrorMessage('')
                sessionStorage.setItem("email", email)
                sessionStorage.setItem("password", "")
                //console.log(loginApiResponse)

                if (loginApiResponse.data.acl.toString() === "0") {
                    navigate("/admin/profile")
                } else {
                    navigate("/admin/dashboard")
                }

            } else {
                setErrorMessage(loginApiResponse.response.data.message)
            }

        } catch (error) {
            //console.log(error)
            setErrorMessage(getErrorMessage(error))
        }
        // Handle validations

    }

    useEffect(() => {
        if (!isTimerActive || timer <= 0) {
            if (timer === 0 && isTimerActive) {
                setIsResendEnabled(true);
                setIsTimerActive(false);
            }
            return;
        }

        const interval = setInterval(() => {
            setTimer(prev => prev - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, [timer, isTimerActive]);

    useEffect(() => {
        const updateSize = () => {
            if (window.innerWidth < 430) {
                setInputSize({
                    width: "60px",
                    height: "60px",
                    fontSize: "28px",
                });
            } else {
                setInputSize({
                    width: "75px",
                    height: "75px",
                    fontSize: "36px",
                });
            }
        };
        updateSize();
        window.addEventListener("resize", updateSize);
        return () => window.removeEventListener("resize", updateSize);
    }, []);


    const handleResendOtp = async () => {
        try {
            const email = document.getElementById('email').value;

            // Call your resend OTP API
            let index = email.indexOf("@");
            if (index === -1) {
                await checkMobileExists(email);
            } else {
                await checkEmailExists(email);
            }

            setIsResendEnabled(false);
            setTimer(60);
            setIsTimerActive(true);
            setReceivedOtp(''); // Clear previous OTP

            //console.log('OTP resent successfully');
        } catch (error) {
            //console.error('Error resending OTP:', error);
        }
    };

    async function getOtp(event) {
        event.preventDefault()
        email = document.getElementById('email').value.trim()

        if (email.includes("@")) {
            if (!isValidEmailAddress(email)) {
                setErrorMessage("Please enter a valid email address.")
                return
            }
            await checkEmailExists(email)
        } else {
            if (!isValidMobileNumber(email)) {
                setErrorMessage("Please enter a valid mobile number.")
                return
            }
            await checkMobileExists(email)
        }

        // Start timer only after successful OTP request
        setTimer(60);
        setIsTimerActive(true);
        setIsResendEnabled(false);
        setReceivedOtp(''); // Clear previous OTP
        // console.log(email)
    }

    function checkEmailExists(email) {
        var bodyFormData;
        bodyFormData = {
            email: email,
            action: 2
        }
        return axios({
            method: 'post',
            url: CROMPTON_URL + 'user/v2/checkEmail',
            data: bodyFormData
        }).then(async response => {
            //console.log(response)
            if (response.status === 200) {
                try {
                    sessionStorage.setItem("email", email)

                    let otpResponse = await getEmailOtp(email)
                    //console.log(otpResponse)

                    if (otpResponse.status === 200) {
                        setErrorMessage('')
                        setHideFlag(false)
                        setDisableFlag(true)
                        //document.getElementById("email").hidden = false;
                        //sessionStorage.setItem("pageFrom", "FP")
                        //navigate("/auth/verify-otp")
                    } else {
                        setErrorMessage(otpResponse.response.data.message)
                    }

                } catch (error) {
                    //console.log(error)
                    setErrorMessage(getErrorMessage(error))
                }
            } else if (response.status === 208) {
                setErrorMessage(response.data.message)
            }


        })
            .catch(
                error => {
                    // console.log(error)
                    setErrorMessage(getErrorMessage(error))
                }
            )
    }

    function checkMobileExists(mobileNumber) {
        var bodyFormData;
        bodyFormData = {
            mobile: mobileNumber,
            action: 2
        }
        return axios({
            method: 'post',
            url: CROMPTON_URL + 'user/v2/checkMobile',
            data: bodyFormData
        }).then(async response => {
            // console.log(response)
            if (response.status === 200) {
                try {
                    sessionStorage.setItem("email", mobileNumber)

                    let otpResponse = await getMobileOtp(mobileNumber)
                    //console.log(otpResponse)

                    if (otpResponse.status === 200) {
                        setErrorMessage('')
                        setHideFlag(false)
                        setDisableFlag(true)
                        //sessionStorage.setItem("pageFrom", "FP")
                        //navigate("/auth/verify-otp")
                    } else {
                        setErrorMessage(otpResponse.response.data.message)
                    }

                } catch (error) {
                    //console.log(error)
                    setErrorMessage(getErrorMessage(error))
                }
            } else if (response.status === 208) {
                setErrorMessage(response.data.message)
            }

        })
            .catch(
                error => {
                    //console.log(error)
                    setErrorMessage(getErrorMessage(error))
                }
            )
    }

    function navigateToSignUpScreen() {
        navigate("/auth/sign-up")
    }

    function navigateToSignInWithOtpScreen() {
        navigate("/auth/login-otp")
    }

    return (
        <Centered
            bgImage="linear-gradient(135deg, #0b83b5 0%, #0b83b5 100%)"
            maincard={
                <Card
                    extra="max-w-[405px] md:max-w-[510px] md:w-[510px] h-max mx-2.5 md:mx-auto mt-[50px] mb-auto py-2.5 px-4 md:!p-[50px] pt-8 md:pt-[50px]">
                    <h3 className="mb-[10px] text-4xl font-bold text-gray-900 dark:text-white">
                        Sign In
                    </h3>
                    <p className="mb-9 ml-1 text-base text-gray-600">
                        Enter your email to sign in!
                    </p>


                    {/* Email */}
                    <InputField
                        variant="auth"
                        extra="mb-3"
                        label="Email or Mobile Number*"
                        placeholder="Email Address or Mobile Number"
                        id="email"
                        type="text"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        disabled={disableFlag}
                    />

                    {/* Password */}
                    <InputFieldPasswordSignIn
                        variant="auth"
                        extra="mb-3"
                        label="Password*"
                        placeholder="Min. 8 characters"
                        id="password"
                        type="password"
                        value={password}
                        hidden={hideFlag}
                    />

                    <CardV3 extra="w-full h-max mt-4 p-2" id = "otpCard" hidden={hideFlag}>
                        <p className="mt-[15px] ml-1 text-[15px] text-gray-600">
                            Enter your Verification code to proceed!
                        </p>

                        <div className="mt-7 mb-4 w-full overflow-x-auto">
                            <div className="flex justify-center gap-3 flex-nowrap px-2">
                                <PinInput
                                    length={4}
                                    initialValue=""
                                    onChange={() => {
                                    }}
                                    type="numeric"
                                    inputMode="number"
                                    style={{padding: "10px"}}
                                    inputStyle={{
                                        borderWidth: "2px",
                                        width: inputSize.width,
                                        height: inputSize.height,
                                        borderColor: "#E0E5F2",
                                        borderRadius: "16px",
                                        color: "#004c86",
                                        fontSize: inputSize.fontSize,
                                    }}
                                    inputFocusStyle={{
                                        borderColor: "#0b83b5",
                                        borderWidth: "3px",
                                    }}
                                    onComplete={(value, index) => {
                                        setReceivedOtp(value);
                                    }}
                                    autoSelect={true}
                                    regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                                />
                            </div>
                        </div>

                        {/* Resend OTP Section */}
                        <div className="mt-6 mb-4 flex flex-col items-center gap-3">
                            {!isResendEnabled && (
                                <p className="text-sm text-gray-500">
                                    Resend OTP in <span className="font-semibold text-[#004c86]">{timer}s</span>
                                </p>
                            )}

                            <button
                                onClick={handleResendOtp}
                                disabled={!isResendEnabled}
                                className={`px-6 py-2 rounded-lg font-medium transition-all duration-200 ${
                                    isResendEnabled
                                        ? 'bg-[#004c86] text-white hover:bg-blue-700 cursor-pointer'
                                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                }`}
                            >
                                Resend OTP
                            </button>
                        </div>
                    </CardV3>
                    {/* Checkbox */}
                    <div className="mb-4 flex items-center justify-between px-2">
                        <div className="flex items-center">
                            {/*<Checkbox/>
                            <p className="ml-2 text-sm font-medium text-navy-700 dark:text-white">
                                Keep me logged In
                            </p>*/}
                        </div>
                        <NavLink className="text-sm font-medium text-[#004c86]  hover:text-[#004c86] dark:text-white"
                                 to={"/auth/reset-password"}>
                            Forgot Password?
                        </NavLink>
                    </div>

                    <button hidden={!hideFlag} onClick={getOtp}
                            className="linear mt-2 w-full rounded-xl bg-[#004c86] py-[12px] text-base font-medium text-white transition duration-200 hover:bg-[#004c86]
                            active:bg-[#004c86]  dark:bg-[#004c86]  dark:text-white dark:hover:bg-[#004c86]  dark:active:bg-gray-700 ">
                        Get OTP & Login
                    </button>

                    <button hidden={hideFlag} onClick={handleUserLogin}
                            className="linear mt-2 w-full rounded-xl bg-[#004c86] py-[12px] text-base font-medium text-white transition duration-200 hover:bg-[#004c86]
                            active:bg-[#004c86]  dark:bg-[#004c86]  dark:text-white dark:hover:bg-[#004c86]  dark:active:bg-gray-700 ">
                        Login
                    </button>

                    {/*<div className="mb-6 mt-6 flex items-center  gap-3">
                        <div className="h-px w-full bg-gray-200 dark:bg-navy-700"/>
                        <p className="text-base text-gray-600 dark:text-white"> or </p>
                        <div className="h-px w-full bg-gray-200 dark:bg-navy-700"/>
                    </div>

                    <div
                        className="mb-6 flex h-[50px] w-full items-center justify-center gap-2 rounded-xl bg-lightPrimary hover:cursor-pointer dark:bg-gray-700" onClick={navigateToSignInWithOtpScreen}>
                        <div className="rounded-full text-xl">
                            <MdVpnKey/>
                        </div>
                        <h5 className="text-sm font-medium text-navy-700 dark:text-white">
                            Sign In with OTP
                        </h5>
                    </div>*/}


                    <div className="mt-4">
          <span className=" text-sm font-medium text-navy-700 dark:text-gray-600">
            Not registered yet?
          </span>
                        {/*<a
                            href="/auth/sign-up"
                            className="ml-1 text-sm font-medium text-[#004c86]  hover:text-[#004c86]  dark:text-white"
                        >
                            Create an account
                        </a>*/}
                        <Link to={"/auth/sign-up"}
                              className="ml-1 text-sm font-medium text-[#004c86]  hover:text-[#004c86]  dark:text-white">
                            Create an account
                        </Link>
                    </div>

                    <span className="errorMessage">
                        {errorMessage}
                    </span>

                </Card>
            }
        />
    );
}
